import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import { Box, CircularProgress, IconButton, MenuItem, TextField } from '@mui/material';
import { Field } from 'formik';
import { FieldAttributes } from 'formik/dist/Field';
import React from 'react';

import { globalTypes } from '@/shared/duck';

interface SelectFormFieldProps extends FieldAttributes<any> {
  id?: string;
  options?: globalTypes.FormSelectFieldOptionType[];
  isLoading?: boolean;
  isErrorIcon?: boolean;
  onErrorIconAction?: () => void;

}

const SelectFormField: React.FC<SelectFormFieldProps> = ({
    id,
    isLoading = false,
    isErrorIcon = false,
    onErrorIconAction,
    required = false,
    fullWidth = true,
    options = [],
    ...props
  },
) => {
  return (
    <Field
      key={id}
      as={TextField}
      required={required}
      select
      fullWidth={fullWidth}
      variant='outlined'
      disabled={isLoading || props.disabled}
      InputProps={
        {
          endAdornment: (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginRight: '1.25rem',
              }}
            >
              {isLoading ? (
                <CircularProgress size={20} />
              ) : isErrorIcon && onErrorIconAction ? (
                <IconButton
                  onClick={onErrorIconAction}
                  color='error'
                  size='small'
                >
                  <CachedOutlinedIcon />
                </IconButton>
              ) : null}
            </Box>
          ),
        }
      }
      {...props}
    >
      {options?.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </Field>
  );
};

export default SelectFormField;